import { Value } from '../types/value.type';

import { privateClient } from './api-client';

export interface CreateFarmDto {
  name: string;
  address: string;
  city: string;
  siret: string;
  active: boolean;
  account: {
    email: string;
    first_name: string;
    last_name: string;
    phone: string;
    org: number;
  };
}

export const farmsApi = {
  getAll: async () => {
    const farms = await privateClient.get('farms/').json<Value[]>();
    const options = farms.map((farm) => ({
      value: farm.id.toString(),
      label: farm.name,
    }));
    return {
      farmsOptions: options,
      farms,
    };
  },
  createOne: async (data: CreateFarmDto) => {
    try {
      const response = await privateClient
        .post('farms/', { json: data })
        .json<CreateFarmDto & { id: number }>();
      return response;
    } catch (error: any) {
      // Handle the error here
      const err = await error.response.text();
      throw new Error(err);
    }
  },
};
